import * as React from 'react'
import styled from 'styled-components'

import * as consent from '@owl-nest/consent'
import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

export function WidgetInstructions() {
  const [open, setOpen] = React.useState(false)

  return (
    <Wrapper>
      <Uppercase6XS>{t('Add images to the column, to display them without vertical gap')}</Uppercase6XS>
      <plume.LinkAsButton type="button" kind="primary" tinted withIcon onClick={() => setOpen(true)}>
        <plume.glyphs.stroke.Bulb size={18} />
        {t('See an exemple in video')}
      </plume.LinkAsButton>
      <plume.Modal
        open={open}
        closable
        onClose={() => setOpen(false)}
        buttons={{
          type: 'button',
          props: {
            type: 'button',
            onClick: () => setOpen(false),
            children: t('Close'),
          },
        }}
      >
        <plume.styles.heading.S>{t('How to use Image Column')}</plume.styles.heading.S>
        <plume.VideoLoader
          consentWall={consent.media.Wall}
          placeholder="https://cdn.loom.com/sessions/thumbnails/356095a19b7743d48f48528b7d2d4220-1652735735312-with-play.gif"
          videoHtml={`<div style="position: relative; padding-bottom: 62.5%; height: 0;"><iframe src="https://www.loom.com/embed/356095a19b7743d48f48528b7d2d4220" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`}
        />
      </plume.Modal>
    </Wrapper>
  )
}

const Uppercase6XS = styled(plume.styles.heading.XXXXXXS)`
  color: ${plume.COLORS.TEXT_SECONDARY};
  text-transform: uppercase;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 5px;

  ${plume.Link} {
    margin-top: 5px;
    display: flex;
    justify-content: center;
  }

  ${plume.Modal} {
    z-index: 2000; // over ckeditor floating toolbar

    ${plume.styles.modal.Body} {
      ${plume.styles.video.Wrapper} {
        padding-bottom: 62.5%; // Looom videos are not 16/9, we adapt the ratio
      }

      ${plume.styles.heading.S} {
        margin-bottom: 15px;
      }
    }
  }
`

type WidgetButtonProps = {
  onClick: () => void
}

export function WidgetButton({ onClick }: WidgetButtonProps) {
  return (
    <plume.EditButton type="button" onClick={onClick} glyph={<plume.glyphs.stroke.Plus size={21} />}>
      {t('Add image')}
    </plume.EditButton>
  )
}
